import { ThemeProps as Prop, ColorProfiles, Components } from '@powdr/constants';

export const componentThemesDefault = {
  [Components.NAVIGATION_DRAWER]: {
    [Prop.BACKGROUND]: '#411312',
    [Prop.CLOSE_BTN_ICON]: '#f2ebd5',
    [Prop.CLOSE_BTN_BG]: '#411312',
  },

  [Components.NAVIGATION_TOGGLE]: {
    [Prop.NAV_TOGGLE_TXT]: '#411312',
    [Prop.NAV_TOGGLE_ICON]: '#411312',
    [Prop.NAV_TOGGLE_TXT_SCROLLED]: '#411312',
    [Prop.NAV_TOGGLE_ICON_SCROLLED]: '#411312',
  },

  [Components.MAIN_NAV]: {
    [Prop.BACKGROUND]: '#411312',
    [Prop.BORDER]: '#f2ebd5',
    [Prop.CONTENT]: '#f2ebd5',
  },
};
